"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { installActivityBreadcrumbs, recordNavigation } from "@/lib/activity-breadcrumbs"

/** Installs the client-side breadcrumb ring buffer once, and records route
 * changes. See lib/activity-breadcrumbs.ts for what this actually captures
 * and why (Glym's feedback-escalation flow only). */
export function ActivityBreadcrumbTracker() {
  const pathname = usePathname()

  useEffect(() => {
    installActivityBreadcrumbs()
  }, [])

  useEffect(() => {
    if (pathname) recordNavigation(pathname)
  }, [pathname])

  return null
}
